(function(){
    'use strict';

    angular
        .module('elogbooks.admin.settings')
        .controller('AdminMeterEditSettingsController', AdminMeterEditSettingsController);

    function AdminMeterEditSettingsController(
        $controller,
        $state,
        messenger,
        moment,
        lodash,
        apiClient,
        settingsCollection,
        recurrenceRulesService,
        elbSettings,
        module,
        fileTypeService
    ) {
        const vm = this;
        const base = $controller('AdminEditSettingsController', {
            $state: $state,
            messenger: messenger,
            moment: moment,
            lodash: lodash,
            apiClient: apiClient,
            settingsCollection: settingsCollection,
            settingsFields: [
                'meter_force_stick_to_date',
                'meter_grace_period_week_before',
                'meter_grace_period_week_after',
                'meter_grace_period_month_before',
                'meter_grace_period_month_after',
                'meter_grace_period_year_before',
                'meter_grace_period_year_after',
                'meter_generate_week_day',
                'meter_generate_month_day',
                'meter_generate_year_day',
                'meter_generate_year_month'
            ],
            elbSettings: elbSettings,
            module: module,
            fileTypeService: fileTypeService,
            validateTabSettings: null,
            buildTabSettingFormTypes: () => ({
                'meter_force_stick_to_date': { type: 'checkbox' },
                'meter_generate_week_day':{ type: 'select', options: recurrenceRulesService.ruleDayOptions, notRequired: true, subLabel: 'METER_GENERATE_WEEK_DAY_SUB_LABEL' },
                'meter_generate_month_day':{ type: 'number', min: 1, max: 31, notRequired: true, subLabel: 'METER_GENERATE_MONTH_DAY_SUB_LABEL', options: { invalid: false} },
                'meter_generate_year_day':{ type: 'number', min: 1, max: 31, notRequired: true, subLabel: 'METER_GENERATE_YEAR_DAY_SUB_LABEL', options: { invalid: false} },
                'meter_generate_year_month':{ type: 'select', options: recurrenceRulesService.ruleMonthOptions, notRequired: true, subLabel: 'METER_GENERATE_YEAR_MONTH_DAY_SUB_LABEL' },
                'meter_grace_period_week_before':{ type: 'number', min: 0, max: 6, notRequired: true, subLabel: 'METER_GRACE_PERIOD_WEEK_BEFORE_SUB_LABEL', options: { invalid: false} },
                'meter_grace_period_week_after':{ type: 'number', min: 0, max: 6, notRequired: true, subLabel: 'METER_GRACE_PERIOD_WEEK_AFTER_SUB_LABEL', options: { invalid: false} },
                'meter_grace_period_month_before':{ type: 'number', min: 0, max: 27, notRequired: true, subLabel: 'METER_GRACE_PERIOD_MONTH_BEFORE_SUB_LABEL', options: { invalid: false} },
                'meter_grace_period_month_after':{ type: 'number', min: 0, max: 27, notRequired: true, subLabel: 'METER_GRACE_PERIOD_MONTH_AFTER_SUB_LABEL', options: { invalid: false} },
                'meter_grace_period_year_before':{ type: 'number', min: 0, max: 364, notRequired: true, subLabel: 'METER_GRACE_PERIOD_YEAR_BEFORE_SUB_LABEL', options: { invalid: false} },
                'meter_grace_period_year_after':{ type: 'number', min: 0, max: 364, notRequired: true, subLabel: 'METER_GRACE_PERIOD_YEAR_AFTER_SUB_LABEL', options: { invalid: false} }
            })
        });

        angular.extend(vm, base);
    }
})();
